<div class="status-container centered">
	<div *ngIf="!started && !finished" class="big-text">{{ 'workflow.hotWire.start' | translate }}</div>
	<div *ngIf="started && !finished" class="big-text">{{ 'workflow.hotWire.started' | translate }}</div>
	<div *ngIf="finished" class="big-text">{{ 'workflow.hotWire.finished' | translate }}</div>
</div>
<div #canvasContainer style="position: fixed">
	<canvas #canvas
		(mousemove)="movePointerMouse($event)" (touchmove)="moveTouch($event)" (touchend)="touchEnd($event)" (touchstart)="moveTouch($event)">
	</canvas>
	<canvas #pathCanvas
		(mousemove)="movePointerMouse($event)" (touchmove)="moveTouch($event)" (touchend)="touchEnd($event)" (touchstart)="moveTouch($event)">
	</canvas>
</div>
<img #image [src]="src" alt="Test konnte nicht geladen werden" class="path-bounding none-selecting" draggable="false" (load)="initCanvas()" hidden/>
